<template>
    <div @click="trackLinkSelection">
        <router-link :to="linkPath" :target="linkTarget">
            <span v-if="displayLabel">{{ linkLabel }}</span>
             <slot></slot>
        </router-link>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps(['link'])
const emit = defineEmits(['track-link-selection'])

const linkPath = computed(() => {
    return props.link ? props.link.path ? props.link.path : null : null
})

const linkLabel = computed(() => {
    return props.link ? props.link.label ? props.link.label : null : null
})

const displayLabel = computed(() => {
    return props.link ? props.link.displayLabel ? props.link.displayLabel : false : false
})

const linkTarget = computed(() => {
    return props.link ? props.link.target ? props.link.target : '' : ''
})

function trackLinkSelection() {
    // console.log('link selection', label.value)
    emit("track-link-selection", linkLabel.value)
}
</script>